module.exports = __webpack_public_path__ + "img/404-image.3fe0b077.jpg";